// @ts-strict-ignore
import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[clickFilter]'
})
export class ClickFilterDirective implements OnInit, OnDestroy {

  @Input() clickFilter: boolean;

  private listener = e => {
    if (!this.clickFilter && this.elementRef.nativeElement.contains(e.target)) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  constructor(private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    document.addEventListener(`click`, this.listener, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener(`click`, this.listener, true);
  }
}
